import React from 'react';

/**
 * Bo in the kung fu poses of the Cast Iron handoff (public/bo/, copied byte
 * for byte from design_handoff_today_cast_iron/assets/bo-kf-*.svg - the
 * files keep their content credentials). CONCEPT ART for the owner to
 * review, not final brand art.
 *
 * Always decorative here: every place Bo stands, the words beside him say
 * what matters, so he is hidden from assistive technology.
 */
const POSES = {
  sifu: '/bo/bo-sifu.svg',
  record: '/bo/bo-record.svg',
  rest: '/bo/bo-rest.svg',
};

// The art's viewBox is 224 x 220.
const ASPECT = 220 / 224;

const BoArt = ({ pose = 'sifu', width, className = '' }) => (
  <img
    src={POSES[pose]}
    alt=""
    aria-hidden="true"
    width={width}
    height={Math.round(width * ASPECT)}
    className={className}
    decoding="async"
  />
);

export default BoArt;
